<template lang="pug">
  div.body.body-table.r-operator-objects-table
    div.table-choose-panel
      div.toolbar-table
        div.select.list Объекты обращения с отходами

        div.toolbar.toolbar--modal
          div.line
            form(@submit.prevent="")
            div.parameters
            div.actions-panel
              e-button-add(@click="addNewRowTable")

      div
        e-table-editable(
        ref="detail"
        :attributes="detailAttr"
        :dataUrl="dataUrl"
        :postUrl="postUrl"
        :patchUrl="patchUrl"
        :deleteUrl="() => null"
        :tableInOnlineMode="tableInOnlineMode"
        :afterFetchData="afterFetchData"
        :afterValidate="afterValidate"
        :prepareRow="prepareRow"
        @sortByField="onSortByField"
        :enablePagination="true"
        @paginate="onPaginate"
        :beforeSaveResponse="beforeSaveResponse"
        :onToggleEditable="onToggleEditable"
        )
          div(slot="buttons" slot-scope="props")
            button(
            v-if="props.acceptEdit"
            @click.stop.prevent="onToggleEditable(props.model)"
            class="row-edit"
            title="Редактировать"
            )
            button(
            v-if="props.acceptEdit"
            @click.stop.prevent="onRemoveOperatorObjectRel(props.model)"
            class="row-delete"
            title="Удалить связь между объектом обращения и оператором"
            )
          div(slot="name" slot-scope="props").field-name
            input(
            v-if="props.model.id && props.model._isUnique"
            v-bind:disabled="$refs.detail.checkBindDisabled('name', props.model)"
            name="name"
            placeholder="Укажите название объекта"
            v-model="props.model['name']"
            @keyup.enter.prevent="$refs.detail.saveRow(props.model, -1, false)"
            @blur="$refs.detail.saveRow(props.model)"
            )
            e-suggestion(
            v-else
            v-bind:disabled="$refs.detail.checkBindDisabled('name', props.model)"
            :model="props.model"
            name="name"
            :suggestionEndpoint="props.attr.suggestion.suggestionEndpoint"
            :transformSuggestions="props.attr.suggestion.transformSuggestions"
            :placeholder="$refs.detail.getPlaceholder(props.model, props.attr, 'name')"
            @enter="$refs.detail.saveRow(props.model, -1, false)"
            @selectItem="$refs.detail.onSelectItem($event, props.model, props.attr)"
            :useInnerSearch="props.attr.suggestion.useInnerSearch"
            :minSuggestLen="props.attr.suggestion.minSuggestLen"
            :options="props.attr.suggestion.options"
            )

</template>

<script>
  import {tko, core, address} from '../../../../api/api-endpoints.js'
  import {tkoOffline} from "../../../../api/api-offline-endpoints"
  import {ACTIONS} from "../../../../config/config"
  import url from '../../../../utils/url'
  import deepCopy from '../../../../utils/deepCopy'

  export default {
    name: 'r-operator-objects-table',
    props: {
      id: null,
      fields: null,
      tabView: null
    },
    data () {
      return {
        operationType: null,
        search: '',
        searchModel: '',
        sort: null,
        paginationQuery: null
      }
    },
    computed: {
      actionsList () {
        let arr = []
        for (let key in ACTIONS) {
          arr.push({
            id: ACTIONS[key].tko_action_id,
            name: ACTIONS[key].label
          })
        }
        return arr
      },
      tableInOnlineMode () {
        return this.$route.params.id
      },
      detailAttr () {
        return {
          name: {
            label: 'Наименование объекта',
            validationRulePattern: '(\\.*)',
            placeholder: 'Выберите существующий либо введите название нового объекта',
            required: true,
            sort: true,
            suggestion: {
              options: [],
              onSelect: this.onSelect,
              suggestionEndpoint: this.suggestionEndpoint,
              transformSuggestions: this.transformSuggestions
            }
          },
          tkoActions: {
            label: 'Назначение объекта',
            validationRulePattern: '(\\.*)',
            placeholder: '',
            suggestion: {
              checkBoxOnLeft: true,
              multiple: true,
              useInnerSearch: true,
              minSuggestLen: 0,
              options: this.actionsList,
              onChange: (e) => e,
              showTags: false
            },
            transform: (model) => {
              let labels = []
              if (model.tkoActions && Array.isArray(model.tkoActions)) {
                model.tkoActions.forEach(id => {
                  let foundIndex = this.actionsList.findIndex(v => v.id == id)
                  if (foundIndex > -1) {
                    labels.push(this.actionsList[foundIndex].name)
                  }
                })
              }
              return labels.join(', ')
            }
          },
          status_id: {
            label: 'Статус объекта',
            required: true,
            sort: true,
            select: {
              options: this.statuses
            },
            transform: (model) => {
              let lbl = ''
              this.statuses.forEach(v => {
                if (v.id == model.status_id) {
                  lbl = v.name
                }
              })
              return lbl
            }
          },
          address: {
            label: 'Местоположение',
            validationRulePattern: '(\\.*)',
            placeholder: 'Начните вводить адрес',
            location: {
              shortMode: true,
              showMapToggleBtn: true
            }
          },
          garbageGroups: {
            label: 'Группа обслуживаемых отходов',
            validationRulePattern: '(\\.*)',
            placeholder: '',
            suggestion: {
              checkBoxOnLeft: true,
              multiple: true,
              useInnerSearch: true,
              minSuggestLen: 0,
              options: this.garbageGroupsOptions,
              onChange: (e) => e,
              showTags: false
            },
            transform: (model) => {
              let labels = []
              if (model.garbageGroups && Array.isArray(model.garbageGroups)) {
                model.garbageGroups.forEach(id => {
                  let foundIndex = this.garbageGroupsOptions.findIndex(v => v.id == id)
                  if (foundIndex > -1) {
                    labels.push(this.garbageGroupsOptions[foundIndex].name)
                  }
                })
              }
              return labels.join(', ')
            }
          }
        }
      },
      dataUrl () {
        if (this.tableInOnlineMode) {
          let routeQuery = {
            query: {
              tko_operator_id: this.id
            }
          }
          if (this.sort) {
            routeQuery.query.sort = this.sort
          }
          if (this.paginationQuery) {
            routeQuery.query = Object.assign(routeQuery.query, this.paginationQuery)
          }
          console.log('realMode')
          return tko.objects(routeQuery)
        }
        console.log('offlineMode')
        return tkoOffline.objectsTable(this.$route.name)
      },
      garbageGroupsOptions () {
        return (this.$store.getters.readUrlEndpoint(this.getCollectionEndpoint()) || {}).garbage_group || []
      },
      statuses () {
        return (this.$store.getters.readUrlEndpoint(this.getCollectionEndpoint()) || {}).status || []
      }
    },
    created () {
      this.fetchData()
    },
    watch: {
      '$route': 'onRouteHandler'
    },
    methods: {
      onRemoveOperatorObjectRel: async function (model) {
        this.$bar.start()
        try {
          const endpoint = this.dataUrl
          const modelCopy = deepCopy(model)
          if (model && model.id) {
            modelCopy.tko_operator_id = null
            await this.$store.dispatch('updateModel', {
              endpoint,
              url: this.patchUrl(this, modelCopy),
              data: modelCopy
            })
            await this.$store.commit('mutateModelDelete', {
              endpoint,
              data: modelCopy
            })
          } else {
            await this.$store.commit('mutateModelDelete', {
              endpoint,
              data: modelCopy
            })
          }
        } catch (e) {
          this.$e.errorBox(e)
        }
        this.$bar.finish()
        return true
      },
      onToggleEditable (model, rowIndex = -1, skipSaveRow = false) {
        if (model && model.id) {
          if (this.$refs.detail.isEdit(model)) {
            this.$refs.detail.closeEditMode(model)
            return
          }
          let prevRoute = url.getRoute(this.$route, true)
          let params = {objectId: model.id}
          if (this.$route.params.id) {
            params.id = this.$route.params.id
          }
          this.$router.push({
            name: this.$route.name + '.objectUpdate',
            params,
            query: {prevRoute}
          })
        } else {
          this.$refs.detail.toggleEditable(model, rowIndex, skipSaveRow)
        }
      },
      onRouteHandler (newRoute, oldRoute) {
        console.log('onRoute', newRoute, oldRoute)
        if (newRoute.name !== oldRoute.name && this.$refs.detail) {
          this.$refs.detail.fetchData()
        }
      },
      onSelect (ctx, $event, model, attr) {
        if ($event && $event.id) {
          model = Object.assign(model, $event)
          ctx.openEditMode(model)
        } else {
          model.id = null
          model.name = ''
          model.tkoActions = []
          model.status_id = ''
          model.address = ''
          model.garbageGroups = []
        }
      },
      suggestionEndpoint (ctx, q) {
        return tko.objects({query: {q: q, 'per-page': 50}})
      },
      transformSuggestions (ctx, response) {
        let data = this.afterFetchData(ctx, response) || {}
        return data.data || []
      },
      /**
       * @returns {Promise}
       */
      saveAllRows () {
        return this.$refs.detail.saveAllRows()
      },
      prepareRow (model) {
        if (this.fields && this.fields.id) {
          model.tko_operator_id = this.fields.id
        }
        return model
      },
      beforeSaveResponse: async function (model, action, offline, ctx) {
        if (!offline && model.dadata && model.dadata.address) {
          let addressFact = await this.$store.dispatch('createModel', {
            url: address.create(model.address_id),
            data: model.dadata.address.data
          })
          model.address_id = addressFact.data.id
        }
        return true
      },
      fetchData () {
        this.$bar.start()
        let promises = []
        promises.push(
          this.$store.dispatch('updateUrlEndpoint',
            {
              endpoint: this.getCollectionEndpoint(),
              fromCache: true
            }
          )
        )
        Promise.all(promises)
          .then(() => this.$bar.finish())
          .catch(() => this.$bar.finish())
      },
      getCollectionEndpoint () {
        return core.collection('garbage_group,status')
      },
      onPaginate (paginationQuery) {
        this.paginationQuery = paginationQuery
      },
      onSortByField ({sort}) {
        this.sort = sort
      },
      afterValidate (ctx, model, errors, els) {
        /*
        // check for prevent duplicate
        if (model.id) {
          let items = ctx.data.data || []
          for (let index = 0; index < items.length; index++) {
            let row = items[index]
            let rowId = row.id
            let modelId = model.id
            if (model._storeUUID && model._storeUUID !== row._storeUUID && rowId == modelId) {
              errors.name = 'Выбранный объект уже был добавлен'
              model._isUnique = false
              // TODO: fix bug in table editable component
              ctx.openEditMode(model)
              setTimeout(() => {
                ctx.openEditMode(model)
              }, 0)
            }
          }
        }
        */
        return errors
      },
      focusOnField (tr, name) {
        try {
          tr.querySelector('[name="' + name + '"]').focus()
        } catch (e) {
          console.error(e)
        }
      },
      afterFetchData (ctx, data) {
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].status) {
            data.data[i].status_id = data.data[i].status.id

            if (data.data[i].actions) {
              data.data[i].tkoActions = data.data[i].actions.map(v => v.id)
            } else {
              data.data[i].tkoActions = []
            }

            if (data.data[i].garbage_groups) {
              data.data[i].garbageGroups = data.data[i].garbage_groups.map(v => v.id)
            } else {
              data.data[i].garbageGroups = []
            }
          }
          if (!data.data[i].dadata) {
            data.data[i].dadata = {}
          }

          if (!data.data[i].hasOwnProperty('_isUnique')) {
            data.data[i]._isUnique = true
          }
        }
        return data
      },
      postUrl (context, model) {
        return tko.objectUpdateOrCreate()
      },
      patchUrl (context, model) {
        return tko.objectUpdateOrCreate(model.id)
      },
      addNewRowTable () {
        const Model = () => ({
          name: '',
          tko_operator_id: this.id || null,
          dadata: {},
          status_id: '',
          latitude: '',
          longitude: '',
          address: '',
          tkoActions: [],
          garbage_groups: [],
          _is_operator_object: true,
          _isUnique: true
        })
        this.$refs.detail.createRow(new Model())
      }
    }
  }
</script>
